'use client';

import { ChartContainer } from '@/lib/components/Chart/ChartContainer';

type OutcomeChartProps = {
  outcomeId: string;
};

export const OutcomeChart = ({ outcomeId }: OutcomeChartProps) => {
  const chartId = `outcome-${outcomeId}`;
  return <ChartContainer chartId={chartId} outcomeIds={[outcomeId]} showTimeControls={true} />;
};
